import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import moment from "moment";
import { PaginationLimit } from "../../Config";
import { useNavigate } from "react-router-dom";
import { FiEdit3 } from "react-icons/fi";
import { Tooltip } from "react-tooltip";
import { capitalizeFirstLetter, truncateText } from "../../helpers";

const MaintenanceTable = ({
    apiData,
    setSelectedData,
    setIsShowEditMaintenance
}) => {
    const [data, setData] = useState([
        {
            deviceName: "",
            extractionTime: "",
            processingTime: "",
            drops: "",
            action: "",
        },
    ]);
    const navigate = useNavigate();
    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [previousId, setPreviousId] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [openActionMenu, setOpenActionMenu] = useState(null);
    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };
    const edit = (item) => {
        setIsShowEditMaintenance(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };

    const ActionBtns = (item) => {
        return (
            <ActionBtnWrapper>
                <div className="flex gap-4 ">
                    <button
                        onClick={() => edit(item)}
                        className={`cursor-pointer text-sm px-4 py-1 rounded-lg ${' text-gray-600'} flex items-center gap-1`}
                    >
                        {/* Edit */}
                        <FiEdit3 size={14} />
                    </button>
                </div>
            </ActionBtnWrapper>
        );
    };

    useEffect(() => {
        if (apiData) {
            const tempData = apiData.map((item) => ({
                lastMaintenance: moment(item.lastMaintenance).format("DD-MMM-YY"),
                nextMaintenance: moment(item.nextMaintenance).format("DD-MMM-YY"),
                vendor: capitalizeFirstLetter(item.vendorName),
                cost: getCostData (item), //<Amount>{'₹' + item.cost}</Amount>,
                // description: item.description.length > 20 ? (
                //     <>
                //         <span id={`tooltip-${item.id}`} >{item.description.substring(0, 20)}...</span>

                //         <Tooltip
                //             anchorSelect={`#tooltip-${item.id}`}
                //             place="top"
                //             content={item.description}
                //             delayShow={100}
                //             variant="custom"
                //             className="![background-color:#DBEAFE] ![color:#000000] ![opacity:1] !p-6 !shadow-lg !rounded-lg z-10 !w-60 "
                //         />
                //     </>
                // ) : (
                //     item.description || "-"
                // ),
                action: ActionBtns(item),
            }));
            setData(tempData);
        }
    }, [apiData, openActionMenu]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const getCostData = (item) => {
        return (
            <div className="flex flex-col gap-1">
                <span className="text-gray-600 text-sm font-medium">{'₹' + item?.cost}</span>
                <span
                    data-tooltip-id={`tooltip-${item.id}`}
                    data-tooltip-content={item.description}
                    data-tooltip-delay-show={500}
                    data-tooltip-place="top"
                    data-tooltip-variant="info"
                    className="text-gray-400 text-sm"
                >
                    {truncateText(item.description, 20)}
                </span>
                <Tooltip id={`tooltip-${item.id}`} className="max-w-[70%] md:max-w-[50%] xl:max-w-[40%] 2xl:max-w-[20%]" />
            </div>
        );
    };

    const columns = React.useMemo(() => {
        if (isMobileView) {

            return [
                {
                    Header: "Last Maintenance",
                    accessor: "lastMaintenance",
                },
                {
                    Header: "Next Maintenance",
                    accessor: "nextMaintenance",
                },
            ];
        }
        return [
            {
                Header: "Vendor",
                accessor: "vendor",
            },
            {
                Header: "Cost",
                accessor: "cost",
            },
            {
                Header: "Last Maintenance",
                accessor: "lastMaintenance",
            },
            {
                Header: "Next Maintenance",
                accessor: "nextMaintenance",
            },
            // {
            //     Header: "Description",
            //     accessor: "description",
            // },
            {
                Header: "Edit",
                accessor: "action",
            },
        ];
    }, [isMobileView]);
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex, pageSize },
        previousPage,
        nextPage,
        setPageSize,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );


    useEffect(() => {
        setCurrentPage(pageIndex);
    }, [pageIndex]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        const rowData = apiData[rowIndex];
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr
                                    {...row.getRowProps({ style: { height: "80px" } })}
                                    hasdata={(apiData?.length > 0).toString()}

                                >
                                    {row.cells.map((cell, cellIndex) => {

                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}

                                            >
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">
                                                <li>
                                                    <strong>Cost</strong>{" "}
                                                    {data[rowIndex].cost}
                                                </li>
                                                <li>
                                                    <strong>Vendor</strong>{" "}
                                                    {data[rowIndex].vendor}
                                                </li>

                                                <li >
                                                    <strong>Description</strong>{" "}
                                                    {data[rowIndex].description}
                                                </li>
                                                <li>
                                                    <strong>Edit:</strong> {data[rowIndex].action}
                                                </li>
                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}

        </>
    );
};


const ActionBtnWrapper = tw.div`flex items-center gap-3 relative cursor-pointer`;
const CustomTable = tw.table` w-full text-gray-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Amount = tw.p`text-gray-600 text-sm flex`

export default MaintenanceTable;
